<template>
  <Container type="card-full">
    <div slot="header">
      <el-button @click="save" :loading="btnLoading">保存</el-button>
<!--      <el-button @click="addRole" :loading="btnLoading">添加角色</el-button>-->
      <!-- <el-button @click="close">关闭</el-button> -->
    </div>
    <div class="main">
      <el-form :model="user" label-position="right"  class="mainfrom from_input">
            <el-form-item label="用户名">
              <el-input v-model="user.username" :maxlength="20" :disabled="true"></el-input>
            </el-form-item>
      </el-form>
      <vggrid ref="xGrid" :list="list" tableheight="700" flexname="" :cols="cols" :showfooter="false"
              :showPage="false" :resizable="true"
              @cellClick="cellClick">
      </vggrid>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vggrid from '../common/vggrid'
  export default {
    name: "userRoleForm",
    data () {
      return {
        user: this.$route.params.form,
        btnLoading: false,
        list: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80},
          { type: 'checkbox',fieldtype: 'I', title: '选择',calculExpr:'', width: 80},
          { field: 'rolename', fieldtype: 'C', title: '角色名称',calculExpr:'',addNewRowFlg: false}
        ],
      }
    },
    activated () {
      this.user = this.$route.params.form,
      this.getPageList()
    },
    watch: {
    },
    filters: {
    },
    components: {vggrid},
    methods: {
      async save () {
        let selectRecords = this.$refs.xGrid.$refs.xGrid.getSelectRecords()
        let model = {
          insertRecords:selectRecords,
          userid: this.user.userid
        }
        this.addOrEdit(model)
      },
      async addRole() {
        this.$router.push({name: 'roleForm', params: {form: this.com}})
      },
      async addOrEdit (model) {
//        if (model.insertRecords.length===0) {
//          this.$message.warning('数据没有修改，不需要保存')
//          return
//        }
        let data = await request({
          url: '/xtgl/userrole/addOrEdit',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.close()
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      },
      async getxGrid(xGrid) {
        this.xGrid = xGrid
      },
      async cellClick (row) {
        this.role = row.row
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xtgl/userrole/getPageList',
          params: {comid: this.user.usercomid,userid: this.user.userid}
        })
        this.list = res
        this.loading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'userIndex'})
      }
    }
  }
</script>


<style lang="scss" scoped>
  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    .content .el-textarea__inner, .el-textarea {
      width: 690px;
    }
    .el-input-group__append, .el-input-group__prepend {
      padding: 0px 5px;
    }
  }
</style>
